(function () {
  'use strict';

  const modalId = 'PdpSizeGuideModal';
  const selectors = {
    open: '[data-pdp-size-guide-open]',
    close: '[data-pdp-size-guide-close]',
    unitToggle: '[data-pdp-size-guide-unit-toggle]',
    unitBtn: '.pdp-size-guide-modal__unit-btn',
    unitSuffix: '[data-pdp-size-guide-unit-suffix]',
    tbody: '[data-pdp-size-guide-tbody]',
    tab: '[data-pdp-size-guide-tab]',
    pane: '.pdp-size-guide-modal__pane',
  };

  function getScrollbarWidth() {
    return window.innerWidth - document.documentElement.clientWidth;
  }

  function openModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'false');
    modal.classList.add('is-open');
    var scrollbarWidth = getScrollbarWidth();
    if (scrollbarWidth > 0) {
      document.documentElement.style.setProperty('--pdp-size-guide-scrollbar-width', scrollbarWidth + 'px');
      document.body.classList.add('pdp-size-guide-modal-open');
      document.body.style.paddingRight = scrollbarWidth + 'px';
    }
    document.body.style.overflow = 'hidden';
    const firstFocus = modal.querySelector('.pdp-size-guide-modal__close');
    if (firstFocus) firstFocus.focus();
  }

  var closeTransitionMs = 300;

  function closeModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    modal.classList.remove('is-open');
    window.setTimeout(function () {
      document.body.style.paddingRight = '';
      document.body.style.overflow = '';
      document.body.classList.remove('pdp-size-guide-modal-open');
      document.documentElement.style.removeProperty('--pdp-size-guide-scrollbar-width');
    }, closeTransitionMs);
  }

  // FIX: 使用事件委托代替直接绑定，解决 variant 切换后 DOM 重建导致事件丢失的问题
  function bindOpen() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest(selectors.open);
      if (!btn) return;
      var id = btn.getAttribute('data-pdp-size-guide-open');
      if (id) openModal(id);
    });
  }

  // FIX: close 也改为事件委托
  function bindClose() {
    document.addEventListener('click', function (e) {
      // 关闭按钮
      var closeEl = e.target.closest(selectors.close);
      if (closeEl) {
        e.stopPropagation();
        var modal = closeEl.closest('.pdp-size-guide-modal');
        if (modal && modal.id) closeModal(modal.id);
        return;
      }
      // backdrop 点击关闭
      if (e.target.classList.contains('pdp-size-guide-modal__backdrop')) {
        var backdropModal = e.target.closest('.pdp-size-guide-modal');
        if (backdropModal && backdropModal.id && backdropModal.classList.contains('is-open')) {
          closeModal(backdropModal.id);
        }
      }
    });
  }

  function bindUnitToggle() {
    document.querySelectorAll(selectors.unitToggle).forEach(function (group) {
      const modal = group.closest('.pdp-size-guide-modal');
      const btns = group.querySelectorAll(selectors.unitBtn);
      const suffixes = modal ? modal.querySelectorAll(selectors.unitSuffix) : [];
      const tbodies = modal ? modal.querySelectorAll(selectors.tbody) : [];

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          const unit = this.getAttribute('data-unit');
          btns.forEach(function (b) { b.classList.remove('active'); });
          this.classList.add('active');
          suffixes.forEach(function (s) { s.textContent = unit; });
          tbodies.forEach(function (tb) {
            var u = tb.getAttribute('data-pdp-size-guide-tbody');
            tb.style.display = u === unit ? '' : 'none';
          });
        });
      });
    });
  }

  function bindTabs() {
    document.querySelectorAll('.pdp-size-guide-modal').forEach(function (modal) {
      const tabs = modal.querySelectorAll(selectors.tab);
      const panes = modal.querySelectorAll(selectors.pane);

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          tabs.forEach(function (t, i) {
            t.classList.toggle('active', i === index);
            t.setAttribute('aria-selected', i === index ? 'true' : 'false');
          });
          panes.forEach(function (p, i) {
            var active = i === index;
            p.classList.toggle('active', active);
            p.hidden = !active;
          });
        });
      });
    });
  }

  function bindEscape(modalIdPrefix) {
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var openModalEl = document.querySelector('.pdp-size-guide-modal.is-open');
      if (openModalEl && openModalEl.id && openModalEl.id.indexOf(modalIdPrefix) === 0) {
        closeModal(openModalEl.id);
      }
    });
  }

  function init() {
    bindOpen();
    bindClose();
    bindUnitToggle();
    bindTabs();
    bindEscape(modalId);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
